import {BaseRequest} from '@/network/requests/BaseRequest'
import {defect_type} from '@/interfaces/defect_type'

export const defectTypeRequest = BaseRequest.build<defect_type>('defect_type')
